import PermissionCheck from '@Components/Utility/PermissionCheck'
import { PERMISSIONS } from '@Const/permissions'
import Button from '@Components/Buttons/Button'
import React from 'react'
import { observer } from 'mobx-react'
import OverclaimSearchStore from '@App/stores/overclaim/overclaim-search-store'
import MlcTooltip from '@Components/Tooltips/MlcTooltip'
import './index.scss'

interface ExportButtonProps {
    overclaimSearchStore: OverclaimSearchStore
    loading: boolean
    disabled?: boolean
    setSidebarIsOpen(b: boolean): void
}

const OverclaimExportButton = (props: ExportButtonProps) => {
    const { loading, setSidebarIsOpen, disabled } = props
    const tooltipId = 'export-button-tooltip'

    return (
        <>
            <PermissionCheck key="export_button" requiredPermissions={[PERMISSIONS.CATALOG_PERMISSIONS.view_works]}>
                <span data-tooltip-id={disabled ? tooltipId : undefined}>
                    <Button
                        submitType="button"
                        mainColor
                        type="secondary"
                        className="export-search-button"
                        disabled={loading || disabled}
                        onClick={() => setSidebarIsOpen(true)}
                    >
                        Export
                    </Button>
                </span>
            </PermissionCheck>
            <MlcTooltip id={tooltipId} place="top-start" variant="info">
                <span>
                    <strong>Clear filters to export.</strong> Exports aren’t available when filters are applied
                </span>
            </MlcTooltip>
        </>
    )
}

export default observer(OverclaimExportButton)
